import { Button, Grid, Typography } from "@mui/material"
import { Constants, Format } from "../../../../../../utils"
import CountUp from "react-countup"
import { useEffect, useRef, useState } from "react"
import moment from "moment"
import { IncrementValue } from "../../../../../../components/incrementValue"
import { ModalPayDaily } from "../modal/payDaily"
import useAuth from "../../../../../../context/auth"
import { ClientsService } from "../../../../../../services/clients"
import { LoadingButton } from "@mui/lab"

export const ValueToPaid = ({
    value,
    parcel
}: {
    value: number,
    parcel: number
}) => {
    const { user, getData } = useAuth()
    const [openModalPay, setOpenModalPay] = useState(false)
    const [loading, setLoading] = useState(false)
    const [code, setCode] = useState("")
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const generateCode = () => {
        setLoading(true)
        ClientsService.generateCodePayment({
            contractId: user?.actualContract?.contract?.id as number,
            parcel: parcel
        })
            .then(({ data }) => {
                setCode(data?.qrCode?.copyAndPaste)
                setOpenModalPay(true)
                startCheckingPaymentStatus(data?.id)
            })
            .finally(() => setLoading(false))
    }

    const checkPaymentStatus = (id: number) => {

        ClientsService.checkPaymentStatus(id)
            .then(({ data }) => {
                if (data.status === "paid") {
                    clearPaymentInterval();
                    getData()
                    setOpenModalPay(false)
                }
            })
    };

    const startCheckingPaymentStatus = (id: number) => {

        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                checkPaymentStatus(id);
            }, 5000);
        }
    };

    const clearPaymentInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };


    useEffect(() => {
        return () => clearPaymentInterval();
    }, []);

    return (
        <Grid
            sx={{
                width: Constants.screenMaxWidth,
                minHeight: "10.02rem",
                backgroundColor: "#FFFFFF",
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                justifyContent: "space-between",
                alignItems: "center",
                padding: ".5rem 2rem",
                boxSizing: "border-box",
                position: "fixed",
                bottom: 0,
                zIndex: 11

            }}
        >
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    flex: 1
                }}
            >
                <Typography fontSize={"1.4rem"} fontWeight={500} sx={{ opacity: 0.5, maxWidth: "20rem" }}>Valor atualizado da(s) diária(s) selecionada(s):</Typography>
                <Typography fontSize={"2rem"} fontWeight={800} color="primary">
                    <IncrementValue value={value} />
                </Typography>
            </Grid>

            <LoadingButton
                variant="contained"
                sx={{
                    fontWeight: 700,
                    width: "13.6rem",
                    height: "4rem",
                    animation: "pulse 2s infinite"
                }}
                onClick={generateCode}
                loading={loading}
            >PAGAR</LoadingButton>
            <ModalPayDaily
                code={code}
                open={openModalPay}
                onClose={() => setOpenModalPay(false)}
            />
        </Grid>
    )
}

export const ValueToPaidDaily = ({
    value,
    dueDate,
    parcel,
    totalParcels
}: {
    value: number,
    totalParcels: number,
    parcel: number,
    dueDate: string
}) => {
    const { user, getData } = useAuth()

    const [openModalPay, setOpenModalPay] = useState(false)
    const [loading, setLoading] = useState(false)
    const [code, setCode] = useState("")
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const generateCode = () => {
        setLoading(true)
        ClientsService.generateCodePayment({
            contractId: user?.actualContract?.contract?.id as number,
            parcel: parcel
        })
            .then(({ data }) => {
                setCode(data?.qrCode?.copyAndPaste)
                setOpenModalPay(true)
                startCheckingPaymentStatus(data?.id)
            })
            .finally(() => setLoading(false))
    }

    const checkPaymentStatus = (id: number) => {

        ClientsService.checkPaymentStatus(id)
            .then(({ data }) => {
                if (data.status === "paid") {
                    clearPaymentInterval();
                    getData()
                    setOpenModalPay(false)
                }
            })
    };

    const startCheckingPaymentStatus = (id: number) => {

        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                checkPaymentStatus(id);
            }, 5000);
        }
    };

    const clearPaymentInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };


    useEffect(() => {
        return () => clearPaymentInterval();
    }, []);


    return (
        <Grid
            sx={{
                width: "100%",
                minHeight: "10.02rem",
                backgroundColor: "#FFFFFF",
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "1rem 2rem",
                boxSizing: "border-box",
                mb: "-2rem",
                borderRadius: "20px"
            }}
        >
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    flex: 1
                }}
            >
                <Typography fontSize={"1.4rem"} fontWeight={700} sx={{ maxWidth: "20rem" }}>Diária atual: {parcel} de {totalParcels}</Typography>
                <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5, maxWidth: "20rem" }}>Venc.: {moment(dueDate).format("DD/MM/YY[ (]dddd[)] [hoje]")}</Typography>
                <Typography fontSize={"2rem"} fontWeight={800} color="primary">
                    <IncrementValue value={value} />
                </Typography>
            </Grid>

            <LoadingButton
                variant="contained"
                sx={{
                    fontWeight: 700,
                    maxWidth: "13.6rem",
                    height: "4rem",
                    animation: "pulse 2s infinite"
                }}
                onClick={generateCode}
                loading={loading}
            >PAGAR</LoadingButton>

            <ModalPayDaily
                code={code}
                open={openModalPay}
                onClose={() => setOpenModalPay(false)}
            />
        </Grid>
    )
}